import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
}

function ZoneAvatar(props: Props) {
  const color = props.color || "#4892cc";
  const name = props.name;

  return (
    <svg
      viewBox="0 0 18 26"
      className={styles.zoneAvatar}
      style={{
        backgroundColor: color,
        fill: isColorLight(color) ? "#000000" : "#FFFFFF",
      }}
    >
      <text x="9" y="18" fontWeight="600" fontSize="14" textAnchor="middle">
        {name[0] ? name[0].toUpperCase() : ""}
      </text>
    </svg>
  );
}

export { ZoneAvatar };
